export const DIMENS = {
  borderRadius1: "0.5rem",
  borderRadius2: "0.75rem",
  borderRadius3: "0.25rem",
  borderRadius4: "1.5rem",
};

export const MOBILE_BREAKPOINT = 960;
